import { render, staticRenderFns } from "./ListWithHeaderLayout.vue?vue&type=template&id=71085422&"
import script from "./ListWithHeaderLayout.vue?vue&type=script&lang=ts&"
export * from "./ListWithHeaderLayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports